/* HW-THEME-17: after Back/Forward (bfcache or HTTP-cache restore) the header cart count kept the value from the
   original page render (e.g. 0 although the cart now holds items). Re-read /cart.js and update every count element
   in place (text only, same element -> no layout shift). Above 99 the Liquid asterisk icon stays untouched. */
(() => {
  function syncCount() {
    fetch((window.Shopify?.routes?.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(response => response.ok ? response.json() : Promise.reject(new Error('Cart read failed')))
      .then(cart => {
        const count = Number(cart?.item_count);
        if (!Number.isInteger(count) || count < 0 || count > 99) return;
        const text = String(count);
        document.querySelectorAll('.thb-item-count').forEach(element => {
          if (element.querySelector('svg')) return;
          if (element.textContent.trim() !== text) element.textContent = text;
        });
      })
      .catch(() => { /* keep the rendered value */ });
  }
  window.addEventListener('pageshow', event => {
    const nav = performance.getEntriesByType?.('navigation')?.[0];
    if (event.persisted || nav?.type === 'back_forward') syncCount();
  });
})();
